/**
 * Where to go after signing in, for the few pages someone reaches from outside
 * the app -- a certificate's printed verification link (ADR-034: verification
 * needs signing in). Session storage, so it lasts only for the sign-in round
 * trip, and only same-site paths are ever followed.
 */
const KEY = 'kudos.returnTo';

export function rememberReturnTo(path: string) {
  try {
    if (isSafe(path)) sessionStorage.setItem(KEY, path);
  } catch {
    // Storage blocked: the person lands on the home page instead.
  }
}

/** The remembered path, once; '/' when there is none. */
export function takeReturnTo(): string {
  try {
    const path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return path && isSafe(path) ? path : '/';
  } catch {
    return '/';
  }
}

function isSafe(path: string) {
  return path.startsWith('/') && !path.startsWith('//') && !path.startsWith('/\\');
}
